import throttle from '../helpers/throttle';
import debounce from '../helpers/debounce';

const $tabBar = $('.js-tab-bar');
const $window = $(window);
let $tabBarList: any;
let hasScroll = false;
let tabBarWidth: number = 0;
let scrollWidth: number = 0;
let windowWidth: number = -1;
let tabBarOffsetY: number = -1;

const HEADER_HEIGHT = 58;
const END_BUFFER = 10;
const SHADOW_CLASS = 'has-shadow-visible';
const FIXED_CLASS = 'is-fixed';

const tabBar = {
  initialize() {
    if (!$tabBar.length) {
      return;
    }

    $tabBarList = $tabBar.find('ul');

    const throttledCheckShadow = throttle(this.checkShadow, 100);
    const debouncedCalculate = debounce(this.calculate, 200);

    this.calculate();
    this.checkFixed($window.scrollTop());

    $window.on('resize load recalculate:size', () => {
      debouncedCalculate();
    });

    $window.on('scroll:virtual', (e: any, scrollTop: number) => {
      this.checkFixed(scrollTop);
    });

    $tabBar.on('mousewheel touchmove', 'ul', () => {
      throttledCheckShadow();
    });
  },

  /**
   * Check if the shadow should be visible based on the scroll position
   * @return {void}
   */
  checkShadow(): void {
    // If there's nothing to scroll we return immediately to prevent wasting
    // valuable resources :)
    if (!hasScroll) {
      return;
    }

    // Check the right scroll position
    const scrollLeft = $tabBarList.scrollLeft() + tabBarWidth;

    // Check if we should show a shadow
    const hasShadow = scrollLeft < (scrollWidth - END_BUFFER);

    // Handle the (un)setting of a shadow class
    if (hasShadow && !$tabBar.hasClass(SHADOW_CLASS)) {
      $tabBar.addClass(SHADOW_CLASS);
    } else if (!hasShadow && $tabBar.hasClass(SHADOW_CLASS)) {
      $tabBar.removeClass(SHADOW_CLASS);
    }
  },

  /**
   * Calculate scroll positions, scroll width, element width and if shadows
   * should be made visible
   * @return {void}
   */
  calculate(): void {
    tabBarWidth = $tabBar.width();
    scrollWidth = $tabBarList[0].scrollWidth;
    windowWidth = $window.width();
    tabBarOffsetY = $tabBar.parent().offset().top;

    hasScroll = scrollWidth > tabBarWidth;

    if (hasScroll && !$tabBar.hasClass(SHADOW_CLASS)) {
      $tabBar.addClass(SHADOW_CLASS);
    } else if (!hasScroll && $tabBar.hasClass(SHADOW_CLASS)) {
      $tabBar.removeClass(SHADOW_CLASS);
    }
  },

  checkFixed(scrollTop: number) {
    const hasFixedScroll = scrollTop >= (tabBarOffsetY - HEADER_HEIGHT);

    if (hasFixedScroll && !$tabBar.hasClass(FIXED_CLASS)) {
      $tabBar.addClass(FIXED_CLASS);
    } else if (!hasFixedScroll && $tabBar.hasClass(FIXED_CLASS)) {
      $tabBar.removeClass(FIXED_CLASS);
    }
  },
};

export default tabBar;
